import { api } from "./configs/axiosConfigs"

export const ProductClassificationAPI = {
    
    getProductClassification: async (data:any, idcompany: number) => {
        const response = await api.get(
            '/classification', { params: {...data, idcompany: idcompany} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getProductClassificationByCompany: async (data:any) => {
        const response = await api.get(
            '/classification/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createProductClassification: async (data: any) => {
        const response = await api.post(
            '/classification/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editProductClassification: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/classification/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteProductClassification: async (idstore: number) => {
        const response = await api.delete(
            `/classification/${idstore}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}